import twitterText from 'twitter-text'
import {split, Syntax} from "sentence-splitter";

function regexLastIndexOf(text, regex, startpos) {
    regex = (regex.global) ? regex : new RegExp(regex.source, "g" + (regex.ignoreCase ? "i" : "") + (regex.multiLine ? "m" : ""));
    if(typeof (startpos) == "undefined") {
        startpos = text.length;
    } else if(startpos < 0) {
        startpos = 0;
    }
    let stringToWorkWith = text.substring(0, startpos + 1);
    let lastIndexOf = -1;
    let nextStop = 0;
    let result
    while((result = regex.exec(stringToWorkWith)) != null) {
        lastIndexOf = result.index;
        regex.lastIndex = ++nextStop;
    }
    return lastIndexOf;
}

export default function getValidTweetFromText(text, extraText) {
	/*
	Gets text for one tweet from the text, returning the good text
	plus the remainder.
	
	This splits things into sentences, and if that doesn't work splits
	into words with ellipses appended.
	
	Extra text will be used when calculating tweet length, but not included
	in what is returned.
	*/
	extraText = extraText || ''
	text = text.trim()
	let fullText = extraText + text
	let tweet = twitterText.parseTweet(fullText)
	if (tweet.valid) {
		// if the whole text is fine, then we just return the whole lot
		return [text]
	} else {
		let maxText = fullText.slice(tweet.validRangeStart + extraText.length, tweet.validRangeEnd + 1)
		let overflow = fullText.slice(tweet.validRangeEnd + 1)
		let sentences = split(maxText)
		
		// if we start with whitespace, pull it out
		if (sentences[0].type === Syntax.WhiteSpace) {
			sentences.shift()
		}
		
		// take off the last part. If we are now empty of have 1 (whitespace)
		// then we have to split up a single sentence
		let lastPart = sentences.pop()
		if (sentences.length <= 1) {
			// we minus 3 to make sure we dont find a space right at the end -
			// then there would be no space for adding the ellipsis
			let lastSpace = regexLastIndexOf(maxText.slice(0, maxText.length - 4), /\s/)
			if (lastSpace === -1) {
				return [text]
			}
			return [
				maxText.slice(0, lastSpace).trim() + ' …',
				'… ' + (maxText.slice(lastSpace) + overflow).trim()
			]
		}
		
		// If last part valid part is , whitespace, then as it happens everything
		// that fits is a full sentence, so we just return that and hte overflow
		if (lastPart.type === Syntax.WhiteSpace) {
			return [sentences.map(sentence => sentence.raw).join(''), overflow]
			
		} else {
			// Otherwise the last part is a sentence fragment we put back into
			// the overflow
			sentences.pop() // last bit is whitespace we can trim
			return [sentences.map(sentence => sentence.raw).join(''), lastPart.raw + overflow]
		}
		
	}
}
